
define('text!templates/parts/menu/context-menu.html',[],function () { return '<ul class="menu-options-list arrow-box {{arrow}}"></ul>\n';});

